import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

/**
 *
 * @param name string
 * @param methods array [Array de string con los metodos deseados (Tiene que existir en availableMethods)]
 * @returns {*}
 */
const generateRESTResources = (name, methods) => {

    let writeBaseUrl = process.env.VUE_APP_ROOT_API_WRITE.replace(/\/+$/, "");
    let readBaseUrl = process.env.VUE_APP_ROOT_API.replace(/\/+$/, "");

    const availableMethods = {
        index: (params) => Vue.http.get(`${readBaseUrl}/${name}`, {params}),
        get: (params) => Vue.http.get(`${readBaseUrl}/${name}/${params.id}`, {params}),
        store: (params) => Vue.http.post(`${writeBaseUrl}/${name}`, params),
        update: (params) => Vue.http.put(`${writeBaseUrl}/${name}/${params.id}`, params),
        delete: (params) => Vue.http.delete(`${writeBaseUrl}/${name}/${params.id}`, {body: params}),
    };

    if (methods === undefined){
        return availableMethods; //Devolvemos todos
    }else{
        return methods.reduce((a, e) => (a[e] = availableMethods[e], a), {}) //Devolvemos solo los que nos solicitan
    }
};

let resources = {
    movieFavorites: generateRESTResources('movie_favorites', ['store', 'delete']),
    movieLikes: generateRESTResources('movie_likes', ['store', 'delete']),
    movieSearchs: generateRESTResources('movie_searchs', ['store']),
    movieView: generateRESTResources('movie_views', ['store']),

    /* Resources */
    posts:  generateRESTResources('posts', ['index', 'get']),
    videos: generateRESTResources('videos', ['index', 'get']),
    movies: generateRESTResources('movies', ['index', 'get']),
    models: generateRESTResources('models', ['index', 'get']),
    movieCategories: generateRESTResources('movie_categories', ['index', 'get']),

    countries: generateRESTResources('countries', ['index']),
    currencies: generateRESTResources('currencies', ['index']),
    country_subdivisions: generateRESTResources('country_subdivisions', ['index']),

    //promotionalCodes: generateRESTResources('promotional_codes', ['index']),
    //subscriptionPlans: generateRESTResources('subscription_plans', ['index']),
    purchaseOptions: generateRESTResources('purchase_options', ['index']),
    promotionalBanners: generateRESTResources('promotional_banners', ['index']),
    subscriptions: generateRESTResources('subscriptions', ['index', 'delete']),
    unsubscriptionRequests: generateRESTResources('unsubscription_requests', ['store']),
    additionalMembershipOffers: generateRESTResources('additional_membership_offers', ['index', 'update']),

    homepageModels: generateRESTResources('models', ['index']),
    homepageMovies: generateRESTResources('movies', ['index']),
    homepageMovieCategories: generateRESTResources('homepage_movie_categories', ['index']),

    languages: generateRESTResources('languages', ['index']),
    payments: generateRESTResources('payments', ['index', 'store', 'get']),
	unavailableEmails: generateRESTResources('unavailable_emails', ['index']),
    unfinishedUsers: generateRESTResources('unfinished_users', ['index']),

	frequentlyAskedQuestions: generateRESTResources('frequently_asked_questions', ['index']),
    
    // oneClickPaymentMethodAvailables: generateRESTResources('payments', ['index']),

    /* Resources */
};

export default resources;